export default __webpack_public_path__ + "static/media/G0005.1be5516b.png";